export class NotFoundError extends Error {
  public requestedPath: string;

  constructor(requestedPath: string) {
    super('Not Found');
    this.requestedPath = requestedPath;

    // tslint:disable-next-line max-line-length
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}
